import React from "react";

export default function AuthCard({
  title,
  children,
}: {
  title?: string;
  children: React.ReactNode;
}) {
  return (
    <div className="border rounded-2xl shadow max-w-lg w-full flex flex-col gap-4 p-6 items-center bg-gradient-to-b from-brand to-[#308ac7]">
      <div className="flex flex-col items-center gap-2">
        <div className="p-1 border-2 rounded-xl shadow-md flex items-center justify-center w-16 h-16 bg-black">
          <img src="/images/logo-3d.png" className="w-full h-auto mx-auto" />
        </div>
        {title && (
          <h1 className="text-xl text-white font-medium text-center drop-shadow">
            {title}
          </h1>
        )}
      </div>

      <div className="max-w-md mx-auto w-full">{children}</div>
    </div>
  );
}
